import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UrlParserTextArea } from 'shared/components/ui/url-parser';
import { useDelayedCallback } from 'shared/hooks/use-delayed-callback';

import * as Styled from './goal-detail-header.style';

export type GoalDetailDescriptionProps = {
  value?: string | null;
  onChange: (value: string) => void;
  disabled?: boolean;
};

export const GoalDetailDescription: React.FC<GoalDetailDescriptionProps> = ({
  value,
  onChange,
  disabled,
}) => {
  const { t } = useTranslation();
  const focussedRef = useRef(false);
  const [tempDescription, setTempDescription] = useState(value ?? '');
  const [delayedOnChange, killOnChangeDelay] = useDelayedCallback(
    onChange,
    500,
  );

  const _onBlur = () => {
    killOnChangeDelay();

    if (disabled || tempDescription === value) {
      return;
    }

    onChange(tempDescription);
  };

  const _onChange = (value: string) => {
    if (disabled) {
      return;
    }

    setTempDescription(value);
    delayedOnChange(value);
  };

  useEffect(() => {
    if (!focussedRef.current) {
      setTempDescription(value ?? '');
    }
  }, [value]);

  return (
    <Styled.DescriptionContainer>
      <UrlParserTextArea
        value={tempDescription}
        placeholder={t('pages.goal-detail.summary.description.placeholder')}
        onChange={_onChange}
        onBlur={_onBlur}
        disabled={disabled}
        linkComponent={Styled.Anchor}
        variant="overline"
        inheritTypography
        respectNewLines
      />
    </Styled.DescriptionContainer>
  );
};
